module.exports = __webpack_public_path__ + "media/markers/powerb_red-f18a4163.svg";